import styled from 'styled-components';
const initBack = require('../../../assets/img/coupon_setting_nodata.png');
const dataBack = require('../../../assets/img/coupon_setting_data.png');

export default styled.div`
  .display-column-between {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .params-icon-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fafafa;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .error_mention {
    display: none;
  }
  .card_wrapper {
    display: flex;
    flex: 1;
    gap: 32px;
  }

  .card_item {
    width: 382px;
    height: 140px;
    display: flex;
    padding: 24px;
    padding-right: 10px;
    /* justify-content: center; */
    /* align-items: center; */
    background: url(${dataBack}) 0 0 no-repeat;
    background-size: cover;
  }
  .addRule {
    width: 382px;
    height: 140px;
    display: flex;
    padding: 24px;
    padding-right: 10px;
    /* justify-content: center; */
    /* align-items: center; */
    background: url(${initBack}) 0 0 no-repeat;
    background-size: cover;
  }
  .button_container {
    .exit {
      margin-left: 16px;
    }
  }
`;
